<template>
  <page>
    <module enable-flex ref="view">
      <m-search ref="search" @search="searchHandle">
        <c-form>
            <c-form-item type="input" label="归属会员" name="performance_user_info" placeholder="模糊匹配昵称、手机号"></c-form-item>
            <c-form-item type="select" label="归属会员等级" name="performance_user_level" options="USER_LEVEL_AUTH"></c-form-item>
          <c-form-item type="input" label="终端单号" name="order_number" placeholder="模糊匹配终端单号"></c-form-item>
          <c-form-item type="input" label="下单会员" name="user_info" placeholder="模糊匹配昵称、手机号"></c-form-item>
          <c-form-item type="select" label="下单会员等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
            <c-form-item type="checkbox" label="状态" name="states" :options="stateType"></c-form-item>
            <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
        <c-button color="m"  power="b_member_performance_record_export" hollow @click="syncExport()">导出业绩明细</c-button>

        <template #right>
          <c-button power="b_member_performance_record_export" v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
        </template>
      </m-operate>
      <c-table ref="table">
        <c-table-column type="selector"></c-table-column>

        <c-table-column label="归属会员头像/昵称" name="nick_name" width="200">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.performance_head_photo" preview size="30" style="margin-right: 10px;">
              </c-image>
              <span>{{ data.performance_nick_name || '--' }}</span>
            </div>
          </template>
        </c-table-column>

        <c-table-column label="归属会员手机号" name="performance_phone" width="120">
          <template v-slot="{data}">
            <span>{{ data.performance_phone }}</span>
          </template>
        </c-table-column>
        <c-table-column label="归属会员等级" name="performance_level_name" width="120">
        </c-table-column>

        <c-table-column label="终端订单号" width="130" name="main_order_number">
<!--          <template v-slot="{data}">
            <a style="color:blue;" @click="navigateTo(`/order_detail/${data.main_order_number}`)">
              {{data.main_order_number}}
            </a>
          </template>-->
        </c-table-column>
        <c-table-column label="下单会员" width="220">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
              <div>
                <span>{{data.user_manage_mobilephone||'-'}}</span><br/>
                <span>{{data.nick_name||'-'}}</span>
              </div>
            </div>
          </template>
        </c-table-column>
        <c-table-column label="下单会员等级" name="level_name" width="120">
        </c-table-column>
        <c-table-column label="状态" name="state" width="80">
          <template v-slot="{data}">
            <span v-if="data.state == 0" style="color:red">{{stateTypeName[data.state] }}</span>
            <span v-if="data.state == 1" style="color:brown">{{stateTypeName[data.state] }}</span>
            <span v-if="data.state == 2" style="color:green">{{stateTypeName[data.state] }}</span>
          </template>
        </c-table-column>
        <c-table-column label="业绩数量" name="settlement_count" width="100"></c-table-column>
        <c-table-column label="业绩金额" name="settlement_money" width="110">
          <template v-slot="{data}">
            ￥{{ parseFloat(data.settlement_money).toFixed(2) }}
          </template>
        </c-table-column>
        <c-table-column label="创建时间" name="create_date" width="155"></c-table-column>
        <c-table-column label="结算时间" name="settlement_date" width="155">
          <template v-slot="{data}">
            <span v-if="data.settlement_date">{{data.settlement_date}}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column label="备注" name="remark" width="200">
          <template v-slot="{data}">
            <span v-if="data.remark">{{data.remark}}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>
      </c-table>
    </module>
  </page>
</template>
<script>
import productInfo from '@/components/public/product_info.vue'
import {mapState} from "vuex";

export default {
  name: 'performance_record_list',

  components: {
    productInfo
  },

  data() {
    return {
      workType: 31,    //云仓台账业务代码
      searchParams:{},
      stateType: [
        {name: '取消清分', value: 0},
        {name: '待清分', value: 1},
        {name: '已经清分', value: 2}
      ],
      stateTypeName: {
        '0': '取消清分',
        '1': '待清分',
        '2': '已经清分'
      }
    }
  },

  computed: {
    ...mapState(['systemConfig', 'userInfo'])
  },

  watch: {},

  mounted() {
    this.$refs.search.search();
  },

  methods: {
    searchHandle(data = {}) {
      this.$refs.table.load({
        url: '/platform_user/performance/record',
        data
      });
      this.searchParams = data||{};
    },
    /**同步导出数据*/
    syncExport() {
      var selectDatas = this.$refs.table.getRow('selected');
      var ids = [];
      if (selectDatas.length && selectDatas.length > 0) {
          ids = Array.from(selectDatas, item => item.data.id);
      }
      this.export(this.workType, this.searchParams, ids);
    }
  }
}
</script>

<style lang="stylus" scoped>
.tag {
  border-radius: 2px;
  padding: 0 5px;
  margin-left: 6px;
  line-height: 18px;
  color: #fff;
}
</style>